export enum CreateEntitiesStrategy {
  Config = 'Config',
  Params = 'Params'
}
